import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { LojaBandaPreco, LojaRequest } from 'pages/cadastro/loja/types';

export function useQueryBandaPreco() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();
    const { setFieldValue } = useFormikContext<LojaRequest>();

    return useQuery(
        ['lojaBandaPrecos'],
        () =>
            requestListagem({
                url: '/gestao/bandapreco',
                sort: [{ property: 'idBandaPreco', direction: 'ASC' }],
                columns: 'idBandaPreco,dsBandaPreco,fgAtivo',
                limit: 20,
            }).then((res) => res.data.data),
        {
            enabled: !id,
            onSuccess: (value: LojaBandaPreco[]) => {
                const lojaConfiguracoes = value.map((item: LojaBandaPreco) => ({
                    ...item,
                    fgAtivo: false,
                    vlPercentual: 0,
                    bandaPreco: { idBandaPreco: item.idBandaPreco, dsBandaPreco: item.dsBandaPreco },
                }));

                setFieldValue('lojaBandaPrecos', lojaConfiguracoes);
            },
        },
    );
}
